<template>
  <div>
    <vx-card class="vx-col w-full mb-base m-auto" title="Leave Type">
      <div class="text-right add-country" v-if="!leaveTypeAddEdit">
        <vs-button
          class="mt-4 mb-5 m-auto gradient-btn"
          @click.prevent="leaveTypeAddEdit = true"
        >Add Leave Type</vs-button>
      </div>
      <form class="w-full" v-if="leaveTypeAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">{{ leaveTypeIndex ? 'Edit' : 'Add' }} Leave Type</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Leave Type"
              v-validate="'required|max:50'"
              name="leavetype_name"
              v-model="leavetype_name"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('leavetype_name') }}</span>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="addUpdateLeaveType()"
              :disabled="button_loading"
              id="leavetype-addupdate"
            >{{ leaveTypeIndex ? 'Save' : 'Add' }}</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddEdit()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5">
        <vs-table :data="leavetypes" pagination max-items="10">
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Deactivate/Activate</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="dept-name">{{ tr.value | capitalize }}</vs-td>
              <vs-td>
                <vs-switch
                  v-model="tr.is_active"
                  @change="confirmDelete(indextr,tr.id,tr.is_active,tr.value)"
                />
              </vs-td>
              <vs-td>
                <vs-button
                  color="#F4B400"
                  type="filled"
                  class="mr-2 mb-2 edit-user float-left"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit Department"
                  @click.stop="editLeaveType(data[indextr])"
                ></vs-button>
                <!--<vs-button
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete Department"
                  @click.stop="confirmDelete(data[indextr].id)"
                ></vs-button>-->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-popup class="holamundo" title="Confirm" :active.sync="popupActive">
        <div class="vx-col vs-lg-12 float-left form-group mb-2 w-full">
          <h5 v-if="status == true">Are you sure you want to activate this leave type?</h5>
          <h5 v-else>Are you sure you want to deactivate this leave type?</h5>
        </div>
        <div class="vx-col vs-lg-12 mt-2 float-left form-group mb-2 w-full">
          <vs-button
            color="success"
            type="filled"
            class="mr-2 edit-user float-left"
            @click.stop="confirmBlockUnblock()"
          >{{status == true ? 'Activate' : 'Deactivate'}}</vs-button>
          <vs-button
            color="warning"
            type="filled"
            class="mr-2 edit-user float-left"
            @click.stop="canclepopup()"
          >Cancel</vs-button>
        </div>
      </vs-popup>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    leavetype_name: {
      required: "Please enter leave type",
      max: "Leave Type name should not be greater than 50 characters"
    }
  }
};
Validator.localize("en", dict);
export default {
  data() {
    return {
      leavetypes: [],
      deleteIndex: 0,
      leaveTypeAddEdit: false,
      popupActive: false,
      leaveTypeIndex: null,
      leavetype_name: null,
      status: null
    };
  },
  created() {},
  mounted() {
    this.getLeaveType();
  },
  methods: {
    getLeaveType() {
      this.$vs.loading({ color: "primary" });

      let url = "leaveType?is_all=true";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.leavetypes = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    addUpdateLeaveType() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#leavetype-addupdate");

          if (this.leaveTypeIndex) {
            this.updateLeaveType();
          } else {
            this.addLeaveType();
          }
        }
      });
    },
    addLeaveType() {
      let input = {
        value: this.leavetype_name
      };
      this.axios
        .post("leaveType", input)
        .then(response => {
          this.button_loader(false, "#leavetype-addupdate");
          let text = "Leave type created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.leaveTypeAddEdit = false;
          this.leavetype_name = null;
          this.getLeaveType();
        })
        .catch(e => {
          this.showError(e, "#leavetype-addupdate");
        });
    },
    editLeaveType(leave) {
      this.leaveTypeAddEdit = true;
      this.leaveTypeIndex = leave.id;
      this.leavetype_name = leave.value;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    updateLeaveType() {
      let input = {
        id: this.leaveTypeIndex,
        value: this.leavetype_name
      };
      this.axios
        .put("leaveType", input)
        .then(response => {
          this.button_loader(false, "#leavetype-addupdate");
          let text = "Leave type updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.leaveTypeAddEdit = false;
          this.leavetype_name = null;
          this.getLeaveType();
        })
        .catch(e => {
          this.showError(e, "#leavetype-addupdate");
        });
    },
    confirmDelete(index, id, status, name) {
      this.deleteIndex = id;
      this.status = status;
      this.popupActive = true;
      this.leavetype_name = name;
    },
    confirmBlockUnblock() {
      let input = {
        id: this.deleteIndex,
        is_active: this.status,
        value: this.leavetype_name
      };
      this.$vs.loading({ color: "primary" });

      this.axios
        .put("leaveType", input)
        .then(response => {
          this.$vs.loading.close();

          if (!this.status) {
            var text = "Leave type has been deactivated successfully";
          } else {
            var text = "Leave type has been activated successfully";
          }

          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = null;
          this.popupActive = false;
          this.status = null;
          this.getLeaveType();
          //this.getApplications();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    canclepopup() {
      this.popupActive = false;
      this.deleteIndex = null;
      this.status = null;
      this.leavetype_name = null;
      this.getLeaveType();
    },
    cancelAddEdit() {
      this.leaveTypeAddEdit = false;
      this.leavetype_name = null;
      this.deleteIndex = null;
      this.leaveTypeIndex = null;
    }
  }
};
</script>
<style>
</style>